import $ from 'cash-dom';
import { Logger } from './logger';

import { NAME__CAMERA_TARGET } from '../constants';

export {
    getCameraTarget,
    getQueryParam,
    getDataProp,
    getObjectByName,
    getObjectsByType,
};

function getQueryParam(name) {
    let params = new URLSearchParams(window.location.search);
    return params.get(name);
}

function getDataProp(selector, propName, defaultValue) {
    return $(selector).data(propName) || defaultValue;
}

function getObjectByName(group, name) {
    let object = null;
    group.traverse((current) => {
        if (current.name !== name) return;
        object = current;
        Logger.info(`${name} found`);
    });
    if (!object) {
        Logger.info(`${name} not found`);
        return null;
    }
    return object;
}

function getObjectsByType(group, constr) {
    if (group instanceof constr) return [group];
    const results = [];
    group.traverse((current) => {
        current instanceof constr && results.push(current);
    });
    return results;
}

function getCameraTarget(group) {
    return getObjectByName(group, NAME__CAMERA_TARGET);
}
